export default __webpack_public_path__ + "src/images/number_region-391c53.png";